'use client';
import { useEffect, useRef, useState } from 'react';
import { Text, Container, Image } from '@weareconceptstudio/core';
import gsap from 'gsap/all';

//* Styles
import HeroMuramoneyStyle from './style';

//* Component
import { animationTitle } from '@/helpers/_animationTitle';

const HeroMuramoney = ({ image, title, description }) => {
	//! State
	const [isLoading, setIsLoading] = useState(false);
	const [getPercent, setGetPercent] = useState(true);

	//! Ref
	const refSplitText = useRef();
	const titleRef = useRef();

	useEffect(() => {
		if (isLoading) {
			gsap.to('.image-wrapper', {
				scale: 1,
				duration: 0.7,
				ease: 'power2.out',
			});
			animationTitle({
				element: titleRef.current,
				ref: refSplitText,
				duration: 0.7,
				delay: 0.1,
				percentFunction: setGetPercent,
				percent: 40,
			});
			gsap.to('.description', {
				opacity: 1,
				duration: 0.7,
				delay: getPercent,
				ease: 'power2.out',
			});
		}
		return () => {
			refSplitText.current?.revert();
		};
	}, [isLoading, getPercent]);
	return (
		<HeroMuramoneyStyle>
			<div className='wrapper-info'>
				<Container row>
					<div className='inner-wrapper-info col-6 col-t-7 col-m-12'>
						<Text
							ref={titleRef}
							className={'uppercase h1 title opacity-zero'}
							tag={'h1'}>
							{title}
						</Text>
						<Text className={'description p3 opacity-zero'}> {description}</Text>
					</div>
				</Container>
			</div>
			<div className='image-wrapper'>
				<Image
					onLoad={setIsLoading}
					double={image}
				/>
			</div>
		</HeroMuramoneyStyle>
	);
};

export default HeroMuramoney;
